import { all, call, put, takeEvery } from 'redux-saga/effects'
import actions from './actions'
import { getCustomerTags, getCustomerAudience } from '../../services/customer'

export function* LIST_TAGS() {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })
  const response = yield call(getCustomerTags)
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        customerTags: response.tags,
      },
    })
  }
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
    },
  })
}

export function* LIST_AUDIENCE({ payload }) {
  yield put({
    type: actions.SET_AUDIENCE_STATE,
    payload: {
      loading: true,
    },
  })
  const response = yield call(getCustomerAudience, payload.filters)
  if (response) {
    yield put({
      type: actions.SET_AUDIENCE_STATE,
      payload: response,
    })
  }
  yield put({
    type: actions.SET_AUDIENCE_STATE,
    payload: {
      loading: false,
    },
  })
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LIST_TAGS, LIST_TAGS)])
  yield all([takeEvery(actions.LIST_AUDIENCE, LIST_AUDIENCE)])
}
